import React from 'react';
import {ResponsiveTypography} from "../styles/typography.responsive";
import {Section} from "./content";
import {cssOnlyDesktop, cssOnlyMobile} from '../styles/utils';
import {Spacing} from "../styles/spacing";

export const Hero = ({title, subtitle, children}) => (
  <Section css={[cssOnlyDesktop(Spacing.Text.center)]}>
    <h1 css={[
      ResponsiveTypography.heading.h3_700,
      Spacing.Margin.horizontal_center,
      cssOnlyMobile(Spacing.Margin.bottom_24),
      cssOnlyDesktop(Spacing.Margin.bottom_16)
    ]}>{title}</h1>
    <h3 css={[ResponsiveTypography.heading.h5_500, Spacing.Margin.horizontal_center]}>{subtitle}</h3>
    <div style={{flexDirection: 'column'}}>
      {children}
    </div>
  </Section>
)
